<div class="form-row">
  <div class="form-group col-md-6">
    <label>Depot</label>
    <ng-select [(ngModel)]="this.depotStockLocation.accountId" class='form-control' [class.is-invalid]='this.depotStockLocation.accountId === -1'
      (change)='this.depotStockLocation.accountId = +$event'>
      @for (item of this.depots; track item) {
        <ng-option [value]='item.id'>{{ item.name }}</ng-option>
      }
    </ng-select>
  </div>
  <div class="form-group col-md-6">
    <label>Stock Location</label>
    <ng-select [(ngModel)]="this.depotStockLocation.warehouseLocationId" class='form-control' [class.is-invalid]='this.depotStockLocation.warehouseLocationId === -1'
      (change)='this.depotStockLocation.warehouseLocationId = +$event'>
      @for (item of this.warehouseLocations; track item) {
        <ng-option [value]='item.id'>{{ item.warehouse?.name }} - {{ item.aisle }}{{ item.shelf ? ' / ' + item.shelf : '' }}</ng-option>
      }
    </ng-select>
  </div>
</div>
